import { AppClient } from "../submodules/rapdv/client/app/AppClient"
import { ClientPage } from "../submodules/rapdv/client/elements/PagesCtrl"
import { PageVerifyEmails } from "./pages/PageVerifyEmails"
import { PageEditPost } from "./pages/PageEditPost"
import { PageEditJob } from "./pages/PageEditJob"
import { selectJsChoicesInit } from "./assets/app/js/choices.js"
import { datePickerInit } from "./assets/app/js/flatpickr.js"
import { DropzoneOrdered } from "./elements/dropzone-ordered/DropzoneOrdered"
import "./assets/app/js/flatpickr.js"
import "./styles/style.scss"
import "./styles/cookies-banner.scss"
import "medium-editor/dist/css/medium-editor.min.css"
import CookiesEuBanner from "cookies-eu-banner/dist/cookies-eu-banner.min.js"
import { PageLogin } from "./pages/PageLogin"
import { PageApplyForJob } from "./pages/PageApplyForJob"

const onPageLoaded = () => {
  selectJsChoicesInit()
  datePickerInit()
  DropzoneOrdered.setupDropzones()
}

const app = new AppClient(onPageLoaded)

const pages: Array<ClientPage> = []
pages.push(new PageLogin())
pages.push(new PageVerifyEmails(app))
pages.push(new PageEditPost())
pages.push(new PageEditJob())
pages.push(new PageApplyForJob())

app.start(pages)
;(window as any).CookiesEuBanner = CookiesEuBanner

new CookiesEuBanner(() => {
  // On cookies accepted
})
